(function () {
  "use strict";

  var CHEVRON =
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="currentColor" fill="none"/></svg>';

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function currentLanguageLabel() {
    var label = document.querySelector(
      "[data-disclosure-locale] [data-disclosure-toggle] .disclosure-list__label"
    );
    if (label && label.textContent.trim()) return label.textContent.trim();
    var htmlLang = document.documentElement.getAttribute("lang") || "";
    if (htmlLang.indexOf("ar") === 0) return "العربية";
    if (htmlLang.indexOf("fr") === 0) return "Français";
    return "English";
  }

  function currentCurrencyCode() {
    var select = document.querySelector("[name=doubly-currencies]");
    if (select && select.value) return select.value;
    var current = document.querySelector(".doubly-nice-select .current");
    if (current) {
      var text = current.textContent.replace(/\s+/g, " ").trim();
      var match = text.match(/[A-Z]{3}/);
      if (match) return match[0];
    }
    return "USD";
  }

  function flagClassForCurrency(code) {
    var option = document.querySelector(
      '[name=doubly-currencies] option[value="' + code + '"]'
    );
    if (!option) return "";
    var country = option.getAttribute("data-country") || "";
    return country ? "flags flags-" + country : "";
  }

  function findIconsHost() {
    return document.querySelector(".header-item--icons .site-nav__icons");
  }

  function insertIntoIcons(wrap) {
    var icons = findIconsHost();
    if (!icons || !wrap) return;
    if (icons.contains(wrap)) return;
    var account = icons.querySelector('a[href="/account"]');
    var cart = icons.querySelector(".js-drawer-open-cart");
    if (account) {
      icons.insertBefore(wrap, account);
    } else if (cart) {
      icons.insertBefore(wrap, cart);
    } else {
      icons.appendChild(wrap);
    }
  }

  function drawerHost() {
    var drawer = document.getElementById("NavDrawer");
    if (!drawer) return null;
    var existing = drawer.querySelector(".header-locale-currency-drawer");
    if (existing) return existing;
    var host = document.createElement("div");
    host.className = "header-locale-currency-drawer";
    var scrollable =
      drawer.querySelector(".drawer__scrollable") ||
      drawer.querySelector(".drawer__inner") ||
      drawer.querySelector(".drawer__contents") ||
      drawer;
    var first = scrollable.firstElementChild;
    if (first) scrollable.insertBefore(host, first);
    else scrollable.appendChild(host);
    return host;
  }

  function isMobileHeader() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function placeControl() {
    var wrap = document.querySelector("[data-header-locale-currency]");
    if (!wrap) return;
    if (isMobileHeader()) {
      var host = drawerHost();
      if (host && wrap.parentNode !== host) {
        closeAll(wrap);
        host.appendChild(wrap);
      }
    } else {
      insertIntoIcons(wrap);
    }
  }

  function closeAll(wrap) {
    if (!wrap) wrap = document.querySelector("[data-header-locale-currency]");
    if (!wrap) return;
    wrap.classList.remove("is-open", "is-open-currency", "is-open-locale");
    wrap.querySelectorAll("[data-header-panel]").forEach(function (panel) {
      panel.hidden = true;
    });
    wrap.querySelectorAll("[data-header-open]").forEach(function (btn) {
      btn.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
    });
  }

  function openPanel(wrap, which) {
    var already =
      (which === "currency" && wrap.classList.contains("is-open-currency")) ||
      (which === "locale" && wrap.classList.contains("is-open-locale"));
    closeAll(wrap);
    if (already) return;
    var panel = wrap.querySelector('[data-header-panel="' + which + '"]');
    var btn = wrap.querySelector('[data-header-open="' + which + '"]');
    if (!panel || !btn) return;
    wrap.classList.add("is-open", "is-open-" + which);
    panel.hidden = false;
    btn.classList.add("is-open");
    btn.setAttribute("aria-expanded", "true");
  }

  function ensureCombinedControl() {
    var icons = findIconsHost();
    if (!icons) return;
    var existing = icons.querySelector("[data-header-locale-currency]");
    if (existing && existing.querySelector("[data-header-open]")) return;
    if (existing) existing.remove();

    var wrap = document.createElement("div");
    wrap.className = "header-locale-currency";
    wrap.setAttribute("data-header-locale-currency", "");

    var toggles = document.createElement("div");
    toggles.className = "header-locale-currency__toggles";

    var currencyBtn = document.createElement("button");
    currencyBtn.type = "button";
    currencyBtn.className = "header-locale-currency__toggle";
    currencyBtn.setAttribute("data-header-open", "currency");
    currencyBtn.setAttribute("aria-expanded", "false");
    currencyBtn.setAttribute("aria-haspopup", "true");
    currencyBtn.innerHTML =
      '<span class="header-locale-currency__flag" aria-hidden="true"></span>' +
      '<span class="header-locale-currency__currency"></span>' +
      CHEVRON;

    var localeBtn = document.createElement("button");
    localeBtn.type = "button";
    localeBtn.className = "header-locale-currency__toggle";
    localeBtn.setAttribute("data-header-open", "locale");
    localeBtn.setAttribute("aria-expanded", "false");
    localeBtn.setAttribute("aria-haspopup", "true");
    localeBtn.innerHTML =
      '<span class="header-locale-currency__lang"></span>' + CHEVRON;

    toggles.appendChild(currencyBtn);
    toggles.appendChild(localeBtn);

    var currencyPanel = document.createElement("div");
    currencyPanel.className = "header-locale-currency__panel";
    currencyPanel.setAttribute("data-header-panel", "currency");
    currencyPanel.hidden = true;

    var localePanel = document.createElement("div");
    localePanel.className = "header-locale-currency__panel";
    localePanel.setAttribute("data-header-panel", "locale");
    localePanel.hidden = true;

    wrap.appendChild(toggles);
    wrap.appendChild(currencyPanel);
    wrap.appendChild(localePanel);

    insertIntoIcons(wrap);
    placeControl();

    currencyBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openPanel(wrap, "currency");
    });
    localeBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openPanel(wrap, "locale");
    });
  }

  function bindGlobalDismiss() {
    if (document.documentElement.hasAttribute("data-header-locale-bound")) return;
    document.documentElement.setAttribute("data-header-locale-bound", "");

    window.addEventListener("resize", function () {
      placeControl();
    });

    document.addEventListener("click", function (event) {
      var wrap = document.querySelector("[data-header-locale-currency]");
      if (!wrap) return;
      if (!wrap.contains(event.target)) closeAll(wrap);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" || event.key === "Esc") {
        closeAll();
      }
    });
  }

  function hideFloatingCurrency() {
    document
      .querySelectorAll(
        ".doubly-float, body > .doubly-nice-select.currency-switcher"
      )
      .forEach(function (el) {
        if (el.closest("[data-header-locale-currency]")) return;
        el.setAttribute("hidden", "");
        el.setAttribute("aria-hidden", "true");
        el.style.setProperty("display", "none", "important");
      });
  }

  function hideNativeChrome(root) {
    if (!root) return;
    root.querySelectorAll(
      ".disclosure__toggle, .faux-select, h2.visually-hidden, .multi-selectors__item > h2"
    ).forEach(function (el) {
      el.setAttribute("hidden", "");
    });
  }

  function buildCurrencyList(panel) {
    if (!panel || panel.querySelector("[data-header-currency-list]")) return;
    var select =
      panel.querySelector("select[name=doubly-currencies]") ||
      document.querySelector("select[name=doubly-currencies]");
    if (!select) return;

    var list = document.createElement("div");
    list.className = "header-locale-currency__list";
    list.setAttribute("data-header-currency-list", "");
    var current = select.value;

    Array.prototype.forEach.call(select.options, function (option) {
      if (!option.value) return;
      var row = document.createElement("button");
      row.type = "button";
      row.className = "header-locale-currency__option";
      if (option.value === current) row.classList.add("is-current");
      row.setAttribute("data-currency", option.value);
      var country = option.getAttribute("data-country") || "";
      var flag = document.createElement("span");
      flag.className = "header-locale-currency__flag" + (country ? " flags flags-" + country : "");
      flag.setAttribute("aria-hidden", "true");
      var name = document.createElement("span");
      name.className = "header-locale-currency__option-name";
      name.textContent = (option.textContent || option.value).replace(/\s+/g, " ").trim();
      row.appendChild(flag);
      row.appendChild(name);
      row.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        select.value = option.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        if (typeof window.jQuery === "function") {
          window.jQuery(select).trigger("change");
        }
        refreshCombinedLabel();
        closeAll();
      });
      list.appendChild(row);
    });

    panel.appendChild(list);
  }

  function uniqueLocaleOptions() {
    var seen = {};
    var items = [];
    document
      .querySelectorAll(
        "[data-disclosure-locale] [data-disclosure-option], [data-disclosure-locale] .disclosure-list__item a, [data-disclosure-locale] .disclosure-list__option"
      )
      .forEach(function (el) {
        var labelEl = el.querySelector(".disclosure-list__label") || el;
        var label = labelEl.textContent.replace(/\s+/g, " ").trim();
        if (!label || seen[label]) return;
        seen[label] = true;
        items.push({ el: el, label: label });
      });
    return items;
  }

  function buildLocaleList(panel) {
    if (!panel || panel.querySelector("[data-header-locale-list]")) return;
    var options = uniqueLocaleOptions();
    if (!options.length) return;

    var list = document.createElement("div");
    list.className = "header-locale-currency__list";
    list.setAttribute("data-header-locale-list", "");
    var current = currentLanguageLabel();

    options.forEach(function (item) {
      var row = document.createElement("button");
      row.type = "button";
      row.className = "header-locale-currency__option";
      if (item.label === current) row.classList.add("is-current");
      row.textContent = item.label;
      row.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof item.el.click === "function") item.el.click();
        refreshCombinedLabel();
        closeAll();
      });
      list.appendChild(row);
    });

    panel.appendChild(list);
  }

  function moveLocaleAndCurrency() {
    var wrap = document.querySelector("[data-header-locale-currency]");
    if (!wrap) return;
    var currencyPanel = wrap.querySelector('[data-header-panel="currency"]');
    var localePanel = wrap.querySelector('[data-header-panel="locale"]');
    if (!currencyPanel || !localePanel) return;

    var localeForm =
      document.querySelector("#localization_formtoolbar") ||
      document.querySelector('.toolbar form[action="/localization"]') ||
      document.querySelector('form.multi-selectors[action="/localization"]');
    if (localeForm && localeForm.parentNode !== localePanel) {
      localePanel.appendChild(localeForm);
    }

    var doubly =
      document.querySelector(".doubly-wrapper.doubly-header") ||
      document.querySelector("#shopify-section-header .doubly-wrapper.doubly-alpha") ||
      document.querySelector(".header-item--icons .doubly-wrapper") ||
      document.querySelector(".doubly-float .doubly-wrapper") ||
      document.querySelector(".doubly-float");
    if (doubly && doubly.parentNode !== currencyPanel) {
      currencyPanel.appendChild(doubly);
    }
    hideFloatingCurrency();

    hideNativeChrome(localePanel);
    buildCurrencyList(currencyPanel);
    buildLocaleList(localePanel);
    refreshCombinedLabel();
  }

  function refreshCombinedLabel() {
    var wrap = document.querySelector("[data-header-locale-currency]");
    if (!wrap) return;
    var currencyEl = wrap.querySelector(".header-locale-currency__currency");
    var langEl = wrap.querySelector(".header-locale-currency__lang");
    var flagEl = wrap.querySelector(".header-locale-currency__flag");
    var code = currentCurrencyCode();
    if (currencyEl) currencyEl.textContent = code;
    if (langEl) langEl.textContent = currentLanguageLabel();
    if (flagEl) {
      flagEl.className = "header-locale-currency__flag " + flagClassForCurrency(code);
    }
    var current = currentLanguageLabel();
    wrap.querySelectorAll("[data-header-locale-list] .header-locale-currency__option").forEach(function (row) {
      row.classList.toggle("is-current", row.textContent.trim() === current);
    });
    wrap.querySelectorAll("[data-header-currency-list] .header-locale-currency__option").forEach(function (row) {
      row.classList.toggle("is-current", row.getAttribute("data-currency") === code);
    });
  }

  function slimOnScroll() {
    var header = document.querySelector(".site-header");
    if (!header) return;

    var ticking = false;
    function update() {
      ticking = false;
      header.classList.toggle("is-slim", window.scrollY > 16);
    }

    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  }

  function watchLateInjections() {
    if (typeof MutationObserver === "undefined") return;
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        placeControl();
        moveLocaleAndCurrency();
        hideFloatingCurrency();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 8000);
  }

  ready(function () {
    ensureCombinedControl();
    bindGlobalDismiss();
    placeControl();
    hideFloatingCurrency();
    moveLocaleAndCurrency();
    slimOnScroll();
    watchLateInjections();
    window.setTimeout(moveLocaleAndCurrency, 400);
    window.setTimeout(moveLocaleAndCurrency, 1200);
    document.addEventListener("click", function () {
      window.setTimeout(refreshCombinedLabel, 50);
    });
  });
})();
